import React from 'react';

import { Chart, Series, CommonSeriesSettings, Legend, ValueAxis, ArgumentAxis, Label, Title, Export, Tooltip } from 'devextreme-react/chart';

// import dataSource from '../../data/engagement_stacked.json';
import { SubAccount, ClientsAPI } from 'src/api'
type Props = {
  client?: SubAccount
}
class StackedLanding extends React.Component<Props> {
  customizeTooltip(arg: { seriesName: any; valueText: any; }) {
    return {
      text: `${arg.seriesName} ${arg.valueText}`
    };
  }

  state = {
    data: undefined,
    narrative: undefined
  }
  fetchData = (client: SubAccount) => {
    const params = {
      narrative_assembly_id: "028124c6-f470-11ea-86cf-0e95a518f8f7",
      report_content_id: "41ba8192-f470-11ea-86cf-0e95a518f8f7",
      sub_account_id: client.id,
      period_index: "1449",
      period_type: "monthly"
    }

    ClientsAPI.getReportData(client, 'engagement_stacked.json').then(result => {
      // console.log('done', result)
      this.setState({ data: result.data });
    }).catch(error => {
      // console.log('error', error)
    })

    ClientsAPI.getNarrative(client, params).then(result => {
      // console.log('done', result)
      this.setState({ narrative: result[0] });
    }).catch(error => {
      // console.log('error', error)
    })
  }
  
  render() {
    const { data, narrative } = this.state
    const { client } = this.props;
    if (!data && client) {
      this.fetchData(client);
    }

    if (!data) return null;

    return (<>
      <Chart
        id="chart"
        title="Top Landing Pages by Users Type"
        dataSource={data}
      >
        <ArgumentAxis>
          <Label
            wordWrap="breakWord"
            overlappingBehavior='rotate'
            rotationAngle='10'
          />
        </ArgumentAxis>
        <CommonSeriesSettings argumentField="landing" type="stackedBar" />
        <Series
          valueField="Not Interested Users"
          name="Not Interested Users"
        />
        <Series
          valueField="Page Turners"
          name="Page Turners"
        />
        <Series
          valueField="Enthusiasts"
          name="Enthusiasts"
        />
        <Series
          valueField="Special Interest"
          name="Special Interest"
        />
        <ValueAxis position="left">
          <Title text="page" />
        </ValueAxis>
        <Legend
          verticalAlignment="bottom"
          horizontalAlignment="center"
          itemTextPosition="top"
        />
        <Export enabled={true} />
        <Tooltip
          enabled={true}
          location="edge"
          customizeTooltip={this.customizeTooltip}
        />
      </Chart>
      </>
    );
  }
}

export default StackedLanding;


// WEBPACK FOOTER //
// ./src/components/ReportComponents/StackedLanding.tsx